import React from 'react';
import styled from 'styled-components';

const StyleSpan = styled.span`
  position: relative;
  display: inline-block;

  .fb-share {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`;

export default ({ className, isShare }) => (
  <StyleSpan className={className}>
    <svg viewBox="0 0 51.3 51.97">
      <path d="M19.22,51.37h9.63l0.01-25.38l8.74,0l0.94-8.75h-9.69l0.01-4.38c0-2.28,0.16-3.5,3.47-3.5h6.12V0.6h-8.77
	c-8.51,0-10.46,4.34-10.46,11.48l0.01,5.15l-6.46,0v8.75h6.46V51.37z"/>
    </svg>
    {!!isShare && <div className="fb-share"></div>}
  </StyleSpan>
)